import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"
import { Offcanvas } from "bootstrap"

export default class OffcanvasController extends Controller {
  static values = {
    autoOpen: Boolean,
    returnTo: String,
  }

  declare autoOpenValue?: boolean
  declare returnToValue?: string

  private offcanvas?: Offcanvas

  connect() {
    this.offcanvas = new bootstrap.Offcanvas(this.element)
    // Enable TurboStream to close offcanvas via custom events
    this.element.addEventListener("offcanvas:close", () => this.close())
    if (this.autoOpenValue) this.open()
  }

  open() {
    this.offcanvas?.show()
  }

  close() {
    this.offcanvas?.hide()
    if (this.returnToValue) Turbo.visit(this.returnToValue, { action: "replace", frame: "_top" })
  }

  disconnect() {
    // Enable TurboStream to close offcanvas via custom events
    this.element.removeEventListener("offcanvas:close", () => this.close())
    this.offcanvas?.dispose()
  }
}
